<script lang="ts">
  import type { ProjectSetting } from '../../modules/projects/project.interface';
  import { Button, Select, ProgressCircular } from 'svelte-materialify';
  import { ProjectSettingValueType } from '../../modules/projects/project.interface';
  import { ProjectConfigService } from '../../modules';
  import { alert } from '../../store';

  export let setting: ProjectSetting;

  let isLoading = false;

  function getList(selectList: string[]) {
    return selectList.map((listItem) => ({ name: listItem, value: listItem }));
  }

  async function update() {
    isLoading = true;

    try {
      await ProjectConfigService.updateProjectSetting(setting);

      window.location.reload();
    } catch (error) {
      alert.show('Problem updating setting!');
    } finally {
      isLoading = false;
    }
  }
</script>

<h6 class="text-body-1">{setting.title}:</h6>
<div class="value-wrapper">
  {#if isLoading}
    <div class="loading-wrapper">
      <ProgressCircular size={40} width={3} indeterminate />
    </div>
  {/if}
  <div class="form-wrapper">
    {#if setting.type === ProjectSettingValueType.MULTI_SELECT}
      <Select
        block
        multiple
        items={getList(setting.selectList)}
        bind:value={setting.value}
      />
    {/if}
  </div>
  <div class="actions">
    <Button class="green white-text" on:click={update}>Update</Button>
  </div>
</div>

<style lang="scss">
  .value-wrapper {
    display: flex;
    position: relative;
  }

  .form-wrapper {
    flex: 1;
    margin-right: 32px;
  }

  .loading-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(white, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }
</style>
